import axios from "axios";
import config from "config/config";
import type { AirlineScore } from "services/scores";
import type { OptionValue } from "../config.d";

const getBySeason = async (season: OptionValue) => {
  try {
    const { data } = await axios.get<AirlineScore[]>(
      `${config.websiteUrl}/api/scores/get-airlines-by-season?season=${season}`
    );

    return data;
  } catch (error) {
    throw Error(error);
  }
};

export default getBySeason;
